<template>
  <footer
    class="mt-7.5 border-t border-gray-light px-5 pb-[calc(110px+env(safe-area-inset-bottom))] pt-5 text-[14px] font-normal text-gray-light lg:px-[60px] lg:pb-[19px] lg:text-[16px]"
  >
    <div
      class="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between"
    >
      <div class="flex flex-col gap-3">
        <NuxtLink to="/" class="block w-fit" aria-label="На главную">
          <img
            src="/logo.webp"
            alt="АгроПромШина"
            class="h-9 w-auto object-contain"
          />
        </NuxtLink>
        <a
          href="tel:+74994033906"
          class="w-fit text-[18px] text-gray-dark transition hover:text-orange"
        >
          8-499-403-39-06
        </a>
        <a
          href="mailto:Info@agropromshina.ru"
          class="w-fit text-[16px] text-gray-dark transition hover:text-orange"
        >
          Info@agropromshina.ru
        </a>
      </div>

      <div class="flex flex-col gap-2 lg:items-center">
        <p>© {{ year }} – ООО «АгроПромШина»</p>
        <NuxtLink to="/info" class="transition hover:text-orange">
          Политика конфиденциальности и обработки персональных данных
        </NuxtLink>
      </div>

      <a
        href="http://titan-it.pro/"
        target="_blank"
        rel="noopener noreferrer"
        class="w-fit transition hover:text-orange"
      >
        Разработка портала
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear();
</script>
